import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=d4890e0a"
import script from "./UserItem.vue?vue&type=script&lang=js"
export * from "./UserItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4890e0a')) {
      api.createRecord('d4890e0a', component.options)
    } else {
      api.reload('d4890e0a', component.options)
    }
    module.hot.accept("./UserItem.vue?vue&type=template&id=d4890e0a", function () {
      api.rerender('d4890e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/main/src/page/chatPage/content/chat/drawer/UserItem.vue"
export default component.exports